import type { GA4ProductData } from './ga4Helper';

export type GTMEcomEventData = Record<string, unknown>;

export const getEcomEventData = (
    eventData: Record<string, unknown>,
): GTMEcomEventData => {
    return {
        ecommerce: eventData,
    };
};

export const getEcomEventItemList = (
    items: GA4ProductData[],
    currency?: string,
): GTMEcomEventData => {
    return getEcomEventData({
        items: items,
        currency: currency || 'NZD',
    });
};
